/**
 * Main JavaScript Entry File
 * Imports all modules
 */

// Import utilities
import './modules/utils';
import './modules/toast';

// Import components
import './modules/navigation';
import './modules/modal';
import './modules/forms';

// Import WooCommerce modules
import './modules/woocommerce';

// Import Elementor widgets (only loads if widget is present)
import './modules/ecommerce-quick-links';
import './modules/action-of-month';
import './modules/swiper-tiles';
import './modules/product-overview';

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    // Initialize all modules
    if (window.CMTheme) {
        window.CMTheme.init();
    }
});
